import { defineComponent as _defineComponent } from 'vue'
import { computed, useContext } from '@nuxtjs/composition-api';
import AnonymityLearnMoreComparisonTable from '@/components/partials/optional-anonymity/AnonymityLearnMoreModal/AnonymityLearnMoreComparisonTable.vue';
import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import Modal from '@/components/common/Modal/Modal.vue';
import CloseIcon from '@/assets/svg/times.vue.svg';
import { OPTIONAL_ANONYMITY_LEARN_MORE_TOOLTIP } from '@/components/partials/optional-anonymity/constants';

type AnonymityLearnMoreModalEmits = {
  (event: 'on-submit'): void;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'AnonymityLearnMoreModal',
  emits: ["on-submit"],
  setup(__props, { emit }: { emit: ({
  (event: 'on-submit'): void;
}), expose: any, slots: any, attrs: any }) {



const { $modal, $tooltip, $constants } = useContext();

const comparison = computed(() => [
  {
    title: 'Choose to be anonymous',
    icon: require('./assets/anonymous.svg'),
    description:
      'If you’d like to post anonymously.\nContent you create <b>will not be linked</b> to your real name and it will go to your anonymous profile.',
  },
  {
    title: 'Choose to post as you',
    icon: require('./assets/real-identity.png'),
    description:
      'If you’d like to build your brand.\nContent you create goes to your public portfolio and <b>linked to your real name.</b>',
  },
]);

function onBeforeClose() {
  if (!$tooltip.isPresent(OPTIONAL_ANONYMITY_LEARN_MORE_TOOLTIP)) {
    $tooltip.close(OPTIONAL_ANONYMITY_LEARN_MORE_TOOLTIP);
  }

  $modal.hide($constants.dynamicModals.OPTIONAL_ANONYMITY_LEARN_MORE_MODAL);
}

function close() {
  onBeforeClose();

  emit('on-submit');
}

return { __sfc: true,emit, $modal, $tooltip, $constants, comparison, onBeforeClose, close, AnonymityLearnMoreComparisonTable, BravadoButtonV3, Modal, CloseIcon }
}

})